// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: overview-widget.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";
import { FieldType, fieldTypeFromJSON, fieldTypeToJSON, ScreenerField } from "./screener";
import {
  Instrument,
  instrumentFromJSON,
  instrumentToJSON,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  Security as Security1,
  SecurityStatus,
  securityStatusFromJSON,
  securityStatusToJSON,
  Segment,
  segmentFromJSON,
  segmentToJSON,
  SettlementIndicator,
  settlementIndicatorFromJSON,
  settlementIndicatorToJSON,
} from "./security";

export const protobufPackage = "com.tick2trade.api.overview";

export interface OverviewWidgetRequest {
  security: Security | undefined;
}

export interface OverviewWidgetResponse {
  security: OverviewWidgetResponse_Security | undefined;
  fieldGroups: OverviewWidgetResponse_FieldGroup[];
  indexComponents: OverviewWidgetResponse_IndexComponent[];
}

export interface OverviewWidgetResponse_Security {
  exchange: Exchange;
  code: string;
  token: number;
  symbol: string;
  name: string;
  displayName: string;
  segment: Segment;
  instrument: Instrument;
  optionType: OptionType;
  securityStatus: SecurityStatus;
  settlementIndicator: SettlementIndicator;
}

export interface OverviewWidgetResponse_Field {
  name: string;
  fieldType: FieldType;
  value: string;
  order: number;
  screenerField: ScreenerField | undefined;
}

export interface OverviewWidgetResponse_FieldGroup {
  name: string;
  fields: OverviewWidgetResponse_Field[];
}

export interface OverviewWidgetResponse_IndexComponent {
  security: Security1 | undefined;
  ltp: number;
  previousClose: number;
  spi: number;
  weightage: number;
}

function createBaseOverviewWidgetRequest(): OverviewWidgetRequest {
  return { security: undefined };
}

export const OverviewWidgetRequest = {
  encode(message: OverviewWidgetRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetRequest {
    return { security: isSet(object.security) ? Security.fromJSON(object.security) : undefined };
  },

  toJSON(message: OverviewWidgetRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetRequest>, I>>(base?: I): OverviewWidgetRequest {
    return OverviewWidgetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetRequest>, I>>(object: I): OverviewWidgetRequest {
    const message = createBaseOverviewWidgetRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    return message;
  },
};

function createBaseOverviewWidgetResponse(): OverviewWidgetResponse {
  return { security: undefined, fieldGroups: [], indexComponents: [] };
}

export const OverviewWidgetResponse = {
  encode(message: OverviewWidgetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      OverviewWidgetResponse_Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.fieldGroups) {
      OverviewWidgetResponse_FieldGroup.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.indexComponents) {
      OverviewWidgetResponse_IndexComponent.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = OverviewWidgetResponse_Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fieldGroups.push(OverviewWidgetResponse_FieldGroup.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.indexComponents.push(OverviewWidgetResponse_IndexComponent.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse {
    return {
      security: isSet(object.security) ? OverviewWidgetResponse_Security.fromJSON(object.security) : undefined,
      fieldGroups: globalThis.Array.isArray(object?.fieldGroups)
        ? object.fieldGroups.map((e: any) => OverviewWidgetResponse_FieldGroup.fromJSON(e))
        : [],
      indexComponents: globalThis.Array.isArray(object?.indexComponents)
        ? object.indexComponents.map((e: any) => OverviewWidgetResponse_IndexComponent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OverviewWidgetResponse): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = OverviewWidgetResponse_Security.toJSON(message.security);
    }
    if (message.fieldGroups?.length) {
      obj.fieldGroups = message.fieldGroups.map((e) => OverviewWidgetResponse_FieldGroup.toJSON(e));
    }
    if (message.indexComponents?.length) {
      obj.indexComponents = message.indexComponents.map((e) => OverviewWidgetResponse_IndexComponent.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse>, I>>(base?: I): OverviewWidgetResponse {
    return OverviewWidgetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse>, I>>(object: I): OverviewWidgetResponse {
    const message = createBaseOverviewWidgetResponse();
    message.security = (object.security !== undefined && object.security !== null)
      ? OverviewWidgetResponse_Security.fromPartial(object.security)
      : undefined;
    message.fieldGroups = object.fieldGroups?.map((e) => OverviewWidgetResponse_FieldGroup.fromPartial(e)) || [];
    message.indexComponents =
      object.indexComponents?.map((e) => OverviewWidgetResponse_IndexComponent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOverviewWidgetResponse_Security(): OverviewWidgetResponse_Security {
  return {
    exchange: 0,
    code: "",
    token: 0,
    symbol: "",
    name: "",
    displayName: "",
    segment: 0,
    instrument: 0,
    optionType: 0,
    securityStatus: 0,
    settlementIndicator: 0,
  };
}

export const OverviewWidgetResponse_Security = {
  encode(message: OverviewWidgetResponse_Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.token !== 0) {
      writer.uint32(24).int32(message.token);
    }
    if (message.symbol !== "") {
      writer.uint32(34).string(message.symbol);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.displayName !== "") {
      writer.uint32(50).string(message.displayName);
    }
    if (message.segment !== 0) {
      writer.uint32(64).int32(message.segment);
    }
    if (message.instrument !== 0) {
      writer.uint32(80).int32(message.instrument);
    }
    if (message.optionType !== 0) {
      writer.uint32(112).int32(message.optionType);
    }
    if (message.securityStatus !== 0) {
      writer.uint32(144).int32(message.securityStatus);
    }
    if (message.settlementIndicator !== 0) {
      writer.uint32(160).int32(message.settlementIndicator);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_Security();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.token = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.segment = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.instrument = reader.int32() as any;
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.securityStatus = reader.int32() as any;
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.settlementIndicator = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      token: isSet(object.token) ? globalThis.Number(object.token) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      segment: isSet(object.segment) ? segmentFromJSON(object.segment) : 0,
      instrument: isSet(object.instrument) ? instrumentFromJSON(object.instrument) : 0,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : 0,
      securityStatus: isSet(object.securityStatus) ? securityStatusFromJSON(object.securityStatus) : 0,
      settlementIndicator: isSet(object.settlementIndicator)
        ? settlementIndicatorFromJSON(object.settlementIndicator)
        : 0,
    };
  },

  toJSON(message: OverviewWidgetResponse_Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.token !== 0) {
      obj.token = Math.round(message.token);
    }
    if (message.symbol !== "") {
      obj.symbol = message.symbol;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.segment !== 0) {
      obj.segment = segmentToJSON(message.segment);
    }
    if (message.instrument !== 0) {
      obj.instrument = instrumentToJSON(message.instrument);
    }
    if (message.optionType !== 0) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    if (message.securityStatus !== 0) {
      obj.securityStatus = securityStatusToJSON(message.securityStatus);
    }
    if (message.settlementIndicator !== 0) {
      obj.settlementIndicator = settlementIndicatorToJSON(message.settlementIndicator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_Security>, I>>(base?: I): OverviewWidgetResponse_Security {
    return OverviewWidgetResponse_Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_Security>, I>>(
    object: I,
  ): OverviewWidgetResponse_Security {
    const message = createBaseOverviewWidgetResponse_Security();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    message.token = object.token ?? 0;
    message.symbol = object.symbol ?? "";
    message.name = object.name ?? "";
    message.displayName = object.displayName ?? "";
    message.segment = object.segment ?? 0;
    message.instrument = object.instrument ?? 0;
    message.optionType = object.optionType ?? 0;
    message.securityStatus = object.securityStatus ?? 0;
    message.settlementIndicator = object.settlementIndicator ?? 0;
    return message;
  },
};

function createBaseOverviewWidgetResponse_Field(): OverviewWidgetResponse_Field {
  return { name: "", fieldType: 0, value: "", order: 0, screenerField: undefined };
}

export const OverviewWidgetResponse_Field = {
  encode(message: OverviewWidgetResponse_Field, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.fieldType !== 0) {
      writer.uint32(24).int32(message.fieldType);
    }
    if (message.value !== "") {
      writer.uint32(42).string(message.value);
    }
    if (message.order !== 0) {
      writer.uint32(48).int32(message.order);
    }
    if (message.screenerField !== undefined) {
      ScreenerField.encode(message.screenerField, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_Field {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_Field();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fieldType = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.value = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.order = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.screenerField = ScreenerField.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_Field {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fieldType: isSet(object.fieldType) ? fieldTypeFromJSON(object.fieldType) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      order: isSet(object.order) ? globalThis.Number(object.order) : 0,
      screenerField: isSet(object.screenerField) ? ScreenerField.fromJSON(object.screenerField) : undefined,
    };
  },

  toJSON(message: OverviewWidgetResponse_Field): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fieldType !== 0) {
      obj.fieldType = fieldTypeToJSON(message.fieldType);
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.order !== 0) {
      obj.order = Math.round(message.order);
    }
    if (message.screenerField !== undefined) {
      obj.screenerField = ScreenerField.toJSON(message.screenerField);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_Field>, I>>(base?: I): OverviewWidgetResponse_Field {
    return OverviewWidgetResponse_Field.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_Field>, I>>(object: I): OverviewWidgetResponse_Field {
    const message = createBaseOverviewWidgetResponse_Field();
    message.name = object.name ?? "";
    message.fieldType = object.fieldType ?? 0;
    message.value = object.value ?? "";
    message.order = object.order ?? 0;
    message.screenerField = (object.screenerField !== undefined && object.screenerField !== null)
      ? ScreenerField.fromPartial(object.screenerField)
      : undefined;
    return message;
  },
};

function createBaseOverviewWidgetResponse_FieldGroup(): OverviewWidgetResponse_FieldGroup {
  return { name: "", fields: [] };
}

export const OverviewWidgetResponse_FieldGroup = {
  encode(message: OverviewWidgetResponse_FieldGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.fields) {
      OverviewWidgetResponse_Field.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_FieldGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_FieldGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fields.push(OverviewWidgetResponse_Field.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_FieldGroup {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      fields: globalThis.Array.isArray(object?.fields)
        ? object.fields.map((e: any) => OverviewWidgetResponse_Field.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OverviewWidgetResponse_FieldGroup): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.fields?.length) {
      obj.fields = message.fields.map((e) => OverviewWidgetResponse_Field.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_FieldGroup>, I>>(
    base?: I,
  ): OverviewWidgetResponse_FieldGroup {
    return OverviewWidgetResponse_FieldGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_FieldGroup>, I>>(
    object: I,
  ): OverviewWidgetResponse_FieldGroup {
    const message = createBaseOverviewWidgetResponse_FieldGroup();
    message.name = object.name ?? "";
    message.fields = object.fields?.map((e) => OverviewWidgetResponse_Field.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOverviewWidgetResponse_IndexComponent(): OverviewWidgetResponse_IndexComponent {
  return { security: undefined, ltp: 0, previousClose: 0, spi: 0, weightage: 0 };
}

export const OverviewWidgetResponse_IndexComponent = {
  encode(message: OverviewWidgetResponse_IndexComponent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security1.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.ltp !== 0) {
      writer.uint32(24).int32(message.ltp);
    }
    if (message.previousClose !== 0) {
      writer.uint32(40).int32(message.previousClose);
    }
    if (message.spi !== 0) {
      writer.uint32(49).double(message.spi);
    }
    if (message.weightage !== 0) {
      writer.uint32(65).double(message.weightage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OverviewWidgetResponse_IndexComponent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverviewWidgetResponse_IndexComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security1.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.ltp = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.previousClose = reader.int32();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.spi = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.weightage = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverviewWidgetResponse_IndexComponent {
    return {
      security: isSet(object.security) ? Security1.fromJSON(object.security) : undefined,
      ltp: isSet(object.ltp) ? globalThis.Number(object.ltp) : 0,
      previousClose: isSet(object.previousClose) ? globalThis.Number(object.previousClose) : 0,
      spi: isSet(object.spi) ? globalThis.Number(object.spi) : 0,
      weightage: isSet(object.weightage) ? globalThis.Number(object.weightage) : 0,
    };
  },

  toJSON(message: OverviewWidgetResponse_IndexComponent): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security1.toJSON(message.security);
    }
    if (message.ltp !== 0) {
      obj.ltp = Math.round(message.ltp);
    }
    if (message.previousClose !== 0) {
      obj.previousClose = Math.round(message.previousClose);
    }
    if (message.spi !== 0) {
      obj.spi = message.spi;
    }
    if (message.weightage !== 0) {
      obj.weightage = message.weightage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverviewWidgetResponse_IndexComponent>, I>>(
    base?: I,
  ): OverviewWidgetResponse_IndexComponent {
    return OverviewWidgetResponse_IndexComponent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverviewWidgetResponse_IndexComponent>, I>>(
    object: I,
  ): OverviewWidgetResponse_IndexComponent {
    const message = createBaseOverviewWidgetResponse_IndexComponent();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security1.fromPartial(object.security)
      : undefined;
    message.ltp = object.ltp ?? 0;
    message.previousClose = object.previousClose ?? 0;
    message.spi = object.spi ?? 0;
    message.weightage = object.weightage ?? 0;
    return message;
  },
};

export interface OverviewWidgetService {
  GetOverviewWidget(request: OverviewWidgetRequest): Promise<OverviewWidgetResponse>;
}

export const OverviewWidgetServiceServiceName = "com.tick2trade.api.overview.OverviewWidgetService";
export class OverviewWidgetServiceClientImpl implements OverviewWidgetService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || OverviewWidgetServiceServiceName;
    this.rpc = rpc;
    this.GetOverviewWidget = this.GetOverviewWidget.bind(this);
  }
  GetOverviewWidget(request: OverviewWidgetRequest): Promise<OverviewWidgetResponse> {
    const data = OverviewWidgetRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOverviewWidget", data);
    return promise.then((data) => OverviewWidgetResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
